import FileUploadSingle from "../../../form/FileUploadSingle";

export const TakeActionForm = ({
  values,
  handleChange,
  errors,
  formValidate,
}) => (
  <div className="grid grid-cols-12 gap-4">
    <div className="relative col-span-6">
      <FileUploadSingle
        label={"Take Action Section Image"}
        labelClasses={"!mb-2"}
        value={values?.sectionImage}
        onChange={(file) =>
          handleChange({ target: { name: "sectionImage", value: file } })
        }
        {...formValidate(errors, "sectionImage")}
      />
    </div>
    <div className="relative col-span-6">
      <FileUploadSingle
        label={"Take Action Sub Image"}
        labelClasses={"!mb-2"}
        value={values?.actionImage}
        onChange={(file) =>
          handleChange({ target: { name: "actionImage", value: file } })
        }
        {...formValidate(errors, "actionImage")}
      />
    </div>
  </div>
);
